export const s3_url =
  "https://awesome-lumen-web-2-31.s3.eu-central-1.amazonaws.com";
